import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propArrayShape, propBool, propFuncList, propNumber, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import Select2FieldsComponent from './Select2FieldsComponent';
const Select2Fields = (props) => {
    const { blurInputOnSelect, candidateValues, classNamePrefix, components, isMulti, isSearchable, maximum, menuPosition, name, placeholder, validate, } = props;
    return (_jsx(Field, { component: Select2FieldsComponent, name: name, props: {
            blurInputOnSelect,
            candidateValues,
            classNamePrefix,
            components,
            isMulti,
            isSearchable,
            maximum,
            menuPosition,
            placeholder,
        }, validate: validate }));
};
Select2Fields.propTypes = {
    blurInputOnSelect: propBool(),
    candidateValues: propArrayShape().isRequired,
    classNamePrefix: propStr(),
    components: propShape(),
    isMulti: propBool(),
    isSearchable: propBool(),
    maximum: propNumber(),
    menuPosition: propStr(),
    name: propStr().isRequired,
    placeholder: propStr(),
    validate: propFuncList(),
};
Select2Fields.defaultProps = {
    blurInputOnSelect: undefined,
    classNamePrefix: undefined,
    components: undefined,
    isMulti: true,
    isSearchable: true,
    maximum: 0,
    menuPosition: undefined,
    placeholder: '',
    validate: [],
};
export default Select2Fields;
